// ══════════════════════════════════════════════════════════════════
// Énumérations partagées front + back (miroir de schema.prisma)
// ══════════════════════════════════════════════════════════════════

export const UserRole = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  GESTIONNAIRE: 'GESTIONNAIRE',
  CITIZEN: 'CITIZEN',
  FIELD_AGENT: 'FIELD_AGENT',
  VIEWER: 'VIEWER',
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

/** Rôles du personnel d'une ville (attribuables par l'admin de la ville) */
export const CITY_STAFF_ROLES = ['ADMIN', 'GESTIONNAIRE', 'FIELD_AGENT', 'VIEWER'] as const;
export type CityStaffRole = (typeof CITY_STAFF_ROLES)[number];

export const CITY_ROLE_DESCRIPTIONS_FR: Record<CityStaffRole, string> = {
  ADMIN: 'Accès complet à la ville : équipe, apparence, abonnement, exports',
  GESTIONNAIRE: 'Traite les signalements (de ses catégories s\'il y est rattaché), saisit les appels',
  FIELD_AGENT: 'Voit ses signalements assignés, met à jour le statut et ajoute les photos après intervention',
  VIEWER: 'Statistiques et carte en lecture seule, sans données personnelles (élus, direction)',
};

export const PlatformRole = { SUPPORT: 'SUPPORT', BILLING: 'BILLING' } as const;
export type PlatformRole = (typeof PlatformRole)[keyof typeof PlatformRole];

export const ReportStatus = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  REJECTED: 'REJECTED',
} as const;
export type ReportStatus = (typeof ReportStatus)[keyof typeof ReportStatus];

export const PriorityLevel = {
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  URGENT: 'URGENT',
} as const;
export type PriorityLevel = (typeof PriorityLevel)[keyof typeof PriorityLevel];

// ── Labels FR ──────────────────────────────────────────────────────
export const REPORT_STATUS_LABELS_FR: Record<ReportStatus, string> = {
  OPEN: 'Nouveau',
  IN_PROGRESS: 'En cours',
  RESOLVED: 'Résolu',
  REJECTED: 'Rejeté',
};

export const PRIORITY_LEVEL_LABELS_FR: Record<PriorityLevel, string> = {
  LOW: 'Basse',
  NORMAL: 'Normale',
  HIGH: 'Haute',
  URGENT: 'Urgente',
};

export const USER_ROLE_LABELS_FR: Record<UserRole, string> = {
  SUPER_ADMIN: 'Super administrateur',
  ADMIN: 'Administrateur',
  GESTIONNAIRE: 'Gestionnaire',
  CITIZEN: 'Citoyen',
  FIELD_AGENT: 'Agent terrain',
  VIEWER: 'Observateur',
};

export const PLATFORM_ROLE_LABELS_FR: Record<PlatformRole, string> = {
  SUPPORT: 'Support GEOSIRA',
  BILLING: 'Facturation GEOSIRA',
};

// ── Couleurs (tokens design system) ────────────────────────────────
export const STATUS_COLORS: Record<ReportStatus, string> = {
  OPEN: 'hsl(0 75% 55%)',
  IN_PROGRESS: 'hsl(25 90% 50%)',
  RESOLVED: 'hsl(120 65% 45%)',
  REJECTED: 'hsl(0 0% 20%)',
};

export const PRIORITY_COLORS: Record<PriorityLevel, string> = {
  LOW: 'hsl(120 65% 45%)',
  NORMAL: 'hsl(45 90% 50%)',
  HIGH: 'hsl(25 90% 50%)',
  URGENT: 'hsl(0 75% 55%)',
};
